import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppState} from '../../app.store';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-landing',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
    date: Date = new Date();
    // user = {
    //   firstName: 'Arash',
    //   lastName: 'Bizhanzadeh',
    //   shortDescription: 'A Geek',
    //   longDescription: 'This is supposed to be a long description about my self, but I don\'t feel like writing it now'
    // }
  private searchResult$: any;
  constructor(private store: Store<AppState>) { }

  ngOnInit() {
    const navbar = document.getElementsByTagName('nav')[0];
    navbar.classList.add('navbar-transparent');
    this.searchResult$ = this.store.select(state => state.user.searchResult);

  }
  ngOnDestroy() {
    const navbar = document.getElementsByTagName('nav')[0];
    navbar.classList.remove('navbar-transparent');
  }
}
